// extracted by mini-css-extract-plugin
export default {"required":"Screen_required__7DX4n","row":"Screen_row__XbeyU","col1":"Screen_col1__D3Ila","col2":"Screen_col2__7l8n4","col3":"Screen_col3__ECQAs"};